<div class="modal-content">
  <div class="modal-header bg-success text-white">
    <h4 class="modal-title">Valmont Coatings Camera Help</h4>
  </div>
  <div class="modal-body">
    <h4>Keyboard Navigation</h4>
    <table class="table w-100 table-sm table-striped">
      <thead class="table-dark">
        <tr>
          <th>Key</th>
          <th>Function</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>A or Left Arrow</td>
          <td>Previous Camera</td>
        </tr>
        <tr>
          <td>D or Right Arrow</td>
          <td>Next Camera</td>
        </tr>
        <tr>
          <td>W or Up Arrow</td>
          <td>Next Site</td>
        </tr>
        <tr>
          <td>S or Down Arrow</td>
          <td>Previous Site</td>
        </tr>
        <tr>
          <td>F</td>
          <td>Toggle Fullscreen</td>
        </tr>
        <tr>
          <td>ESC</td>
          <td>Exit Fullscreen</td>
        </tr>
      </tbody>
    </table>
    <a
      class="fw-bold"
      href="https://cdn.valmontcoatings.net/docs/Valmont%20Coatings%20Camera%20Web%20App.pdf"
      target="_blank"
      >User Guide</a
    >
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-dark float-end" (click)="activeModal.close()">
      Close
    </button>
  </div>
</div>
